// package: vertexvis.protobuf.scenetree.v1alpha1
// file: scenetree/protos/scene_tree_api.proto

var scenetree_protos_scene_tree_api_pb = require("../../scenetree/protos/scene_tree_api_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var SceneTreeAPI = (function () {
  function SceneTreeAPI() {}
  SceneTreeAPI.serviceName = "vertexvis.protobuf.scenetree.v1alpha1.SceneTreeAPI";
  return SceneTreeAPI;
}());

SceneTreeAPI.GetTree = {
  methodName: "GetTree",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.GetTreeRequest,
  responseType: scenetree_protos_scene_tree_api_pb.GetTreeResponse
};

SceneTreeAPI.ExpandNode = {
  methodName: "ExpandNode",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.ExpandNodeRequest,
  responseType: scenetree_protos_scene_tree_api_pb.ExpandNodeResponse
};

SceneTreeAPI.CollapseNode = {
  methodName: "CollapseNode",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.CollapseNodeRequest,
  responseType: scenetree_protos_scene_tree_api_pb.CollapseNodeResponse
};

SceneTreeAPI.Subscribe = {
  methodName: "Subscribe",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: true,
  requestType: scenetree_protos_scene_tree_api_pb.SubscribeRequest,
  responseType: scenetree_protos_scene_tree_api_pb.SubscribeResponse
};

SceneTreeAPI.Filter = {
  methodName: "Filter",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.FilterRequest,
  responseType: scenetree_protos_scene_tree_api_pb.FilterResponse
};

SceneTreeAPI.LocateItem = {
  methodName: "LocateItem",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.LocateItemRequest,
  responseType: scenetree_protos_scene_tree_api_pb.LocateItemResponse
};

SceneTreeAPI.ExpandAll = {
  methodName: "ExpandAll",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.ExpandAllRequest,
  responseType: scenetree_protos_scene_tree_api_pb.ExpandAllResponse
};

SceneTreeAPI.CollapseAll = {
  methodName: "CollapseAll",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.CollapseAllRequest,
  responseType: scenetree_protos_scene_tree_api_pb.CollapseAllResponse
};

SceneTreeAPI.GetNodeAncestors = {
  methodName: "GetNodeAncestors",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.GetNodeAncestorsRequest,
  responseType: scenetree_protos_scene_tree_api_pb.GetNodeAncestorsResponse
};

SceneTreeAPI.GetAvailableColumns = {
  methodName: "GetAvailableColumns",
  service: SceneTreeAPI,
  requestStream: false,
  responseStream: false,
  requestType: scenetree_protos_scene_tree_api_pb.GetAvailableColumnsRequest,
  responseType: scenetree_protos_scene_tree_api_pb.GetAvailableColumnsResponse
};

exports.SceneTreeAPI = SceneTreeAPI;

function SceneTreeAPIClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

SceneTreeAPIClient.prototype.getTree = function getTree(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.GetTree, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.expandNode = function expandNode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.ExpandNode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.collapseNode = function collapseNode(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.CollapseNode, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.subscribe = function subscribe(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(SceneTreeAPI.Subscribe, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.filter = function filter(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.Filter, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.locateItem = function locateItem(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.LocateItem, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.expandAll = function expandAll(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.ExpandAll, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.collapseAll = function collapseAll(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.CollapseAll, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.getNodeAncestors = function getNodeAncestors(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.GetNodeAncestors, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SceneTreeAPIClient.prototype.getAvailableColumns = function getAvailableColumns(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SceneTreeAPI.GetAvailableColumns, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.SceneTreeAPIClient = SceneTreeAPIClient;

